import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/dataManagement';
const wisdomSupport: Array<RouteConfig> = [
    {
        path: 'data-manage/wisdom-support',
        name: 'wisdomSupport',
        redirect: { name: 'smartSuggestion' },
        meta: {
            menuMatch: 'smartSuggestion',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'smart-suggestion',
                name: 'smartSuggestion',
                component: () => import(`@/${BASE_PATH}/wisdomSupport/WisdomSupport.vue`),
                meta: {
                    index: '3-1',
                    title:'智能建议设定',
                    subPage:'smartSuggestionDetail'
                },
            },
            {
                path: 'smart-suggestion-detail',
                name: 'smartSuggestionDetail',
                component: () => import(`@/${BASE_PATH}/wisdomSupport/WisdomSupportDetail.vue`),
                meta: {
                    index: '3-1',
                    title:'智能建议设定',
                    supPage:'smartSuggestion'
                },
            },
            {
                path: 'smart-warning',
                name: 'smartWarning',
                component: () => import(`@/${BASE_PATH}/wisdomSupport/WisdomSupport.vue`),
                meta: {
                    index: '3-2',
                    title:'智能预警设定',
                    subPage:'smartWarningDetail'
                },
            },
            {
                path: 'smart-warning-detail',
                name: 'smartWarningDetail',
                component: () => import(`@/${BASE_PATH}/wisdomSupport/WisdomSupportDetail.vue`),
                meta: {
                    index: '3-2',
                    title:'智能预警设定',
                    supPage:'smartWarning'
                },
            },
            {
                path: 'soil-testing-formula',
                name: 'soilTestingFormula',
                component: () => import(`@/${BASE_PATH}/wisdomSupport/WisdomSupport.vue`),
                meta: {
                    index: '3-3',
                    title:'测土配方设定',
                    subPage:'soilTestingFormulaDetail'
                },
            },
            {
                path: 'soil-testing-formula-detail',
                name: 'soilTestingFormulaDetail',
                component: () => import(`@/${BASE_PATH}/wisdomSupport/SoilTestingFormulaDetail.vue`),
                meta: {
                    index: '3-3',
                    title:'测土配方设定',
                    supPage:'soilTestingFormula'
                },
            },
        ],
    },
];
export default wisdomSupport;